import { Modal } from "react-bootstrap"


const SelctCampModal = ({ show, hideModal, action, camps, title }) => {
    return (
        <Modal
            dialogClassName="h_auto"
            show={show}
            animation={true}
            centered
        >
            <Modal.Header>
                <h6>{title}</h6>
                <span className="modal_close" onClick={hideModal}><i className="icon-cross" /></span>
            </Modal.Header>
            <Modal.Body className="p-3 d-flex flex-column flex-md-row justify-content-between">
                {camps.map(c =>
                    <button className='btn btn-sm btn-outline-dark m-1 p-3' key={c.campId} onClick={() => action(c.campId)}>
                       <b>{  c.campName.toUpperCase() }</b> 
                    </button>)}
            </Modal.Body>
        </Modal>
    )
}

export default SelctCampModal
